import styles from './DocumentsInfo.module.css';

import settingsIcon from 'assets/svg/settings-01.svg';
import documentIcon from 'assets/svg/document-01.svg';
import arrowIcon from 'assets/svg/arrow-01.svg';

import Card from 'ui/Card';
import Icon from 'ui/Icon';
import IconButton from 'ui/IconButton';
import RegularButton from 'ui/RegularButton';
import { address_server_short } from '../../../../../config';
import { projectsStore } from 'store/mobx/projects.store';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import classNames from 'classnames';

const MAX_VISIBLE_DOCUMENTS_PREVIEW = 4;

const DocumentsInfo = observer(({ setModalOpened }) => {
  const { selectedProject } = projectsStore;
  const [expandDocumentPreview, setExpandDocumentPreview] = useState(false);
  const [projectDocuments, setProjectDocuments] = useState([]);

  const handleEditDocumentClick = () => setModalOpened(true);

  useEffect(() => {
    const maxVisibleItems = selectedProject?.files?.slice(
      0,
      expandDocumentPreview ? selectedProject?.files?.length : MAX_VISIBLE_DOCUMENTS_PREVIEW,
    );
    setProjectDocuments(maxVisibleItems);
  }, [selectedProject?.files, expandDocumentPreview]);

  const Document = ({ key, doc }) => {
    const isProduction = process.env.NODE_ENV === 'production';
    const cleanPath = doc.file.replace(/^\/+/, '').replace(/\/+/g, '/');
    const encodedPath = encodeURI(cleanPath);
    const fullPath = `${isProduction ? 'public/' : ''}${encodedPath}`;

    return (
      <div key={key} className={styles.column}>
        <Icon width={'16px'} height={'16px'} color={'var(--color-secondary)'} src={documentIcon} />
        <a
          href={`${address_server_short}/${fullPath}`}
          target="_blank"
          download={cleanPath.split('/').pop()}
          aria-label="Ссылка на просмотр или скачивание"
          className={styles.documentText}
        >
          {doc.file?.split('/').pop()}
        </a>
      </div>
    );
  };

  return (
    <Card>
      <Card.Title text={'Документы'}>
        <IconButton tooltip={'Настройки'} icon={settingsIcon} onClick={handleEditDocumentClick} />
      </Card.Title>
      <Card.Content className={styles.documentInfo}>
        <div className={styles.gridDocuments}>
          {(projectDocuments?.length &&
            projectDocuments.map((doc) => <Document doc={doc} key={doc.id} />)) || (
            <div>Документы не добавлены</div>
          )}
        </div>
        <RegularButton
          className={styles.expandButton}
          text={expandDocumentPreview ? 'Свернуть' : 'Развернуть'}
          variant={'outlined'}
          color={'secondary'}
          onClick={() => setExpandDocumentPreview(!expandDocumentPreview)}
          disabled={
            !projectDocuments?.length ||
            selectedProject?.files?.length <= MAX_VISIBLE_DOCUMENTS_PREVIEW
          }
          appendIcon={
            <Icon
              className={classNames(styles.expandIcon, {
                [styles.expandedIcon]: expandDocumentPreview,
              })}
              color={'var(--color-secondary)'}
              src={arrowIcon}
              width={'14px'}
              height={'14px'}
            />
          }
        />
      </Card.Content>
    </Card>
  );
});

export default DocumentsInfo;
